import { externalLinks } from "@/utils/external-links";
import { Button } from "@mui/material";

export function ContactButton() {
  return (
    <Button
      variant="contained"
      href={externalLinks.whatsapp}
      target="_blank"
      sx={{ fontSize: { xs: "14px", sm: "16px", fontWeight: "bold" }, textTransform: "uppercase" }}
    >
      Entrar em contato
    </Button>
  );
}
